const creativeTypes = {
  Marketing: 'Marketing',
  System: 'System',
  Newsletter: 'Newsletter',
  Welcome: 'Welcome',
  Retention: 'Retention',
  Educational: 'Educational'
};

export default creativeTypes;
  